import { Box, Button, ButtonProps, SxProps, Tooltip, Theme } from "@mui/material";
import { CaseReviewStatus, displayReviewStatus } from "Backend";
import { useNavigate } from "react-router-dom";
import { Case } from "generated/graphql";
import { P } from "theme/typography";
import { InfoOutlined } from "@mui/icons-material";

export interface CaseActionsProps {
  sx: SxProps<Theme>;
  lensCase: Case;
}

const CaseActions = (props: CaseActionsProps) => {
  const navigate = useNavigate();
  const { sx, lensCase } = props;

  const reviewButton = (reviewStatus?: CaseReviewStatus) => {
    let text = "Start Reviewing";
    const color: ButtonProps["color"] = "primary";
    let variant: ButtonProps["variant"] = "contained";
    const onClick = () => navigate("profile");
    if (reviewStatus === CaseReviewStatus.Complete) {
      text = "View Completed Profile";
      variant = "outlined";
    } else if (reviewStatus === CaseReviewStatus.NewDocuments) {
      text = "Review new documents";
    } else if (reviewStatus === CaseReviewStatus.NoDocuments) {
      text = "View Profile";
    }

    return (
      <Button
        fullWidth
        size="large"
        color={color}
        variant={variant}
        disabled={false}
        onClick={onClick}
        id="case-profile-review">
        {text}
      </Button>
    );
  };

  return (
    <Box sx={sx}>
      <Box mt={2}>
        <Box mb={1.5}>
          <P variant="xlBold">Review Status: {displayReviewStatus(lensCase.reviewStatus)}</P>
          {lensCase.reviewStatusReason && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 0.5,
                gap: 0.5,
              }}>
              <Tooltip title="Case Reopened">
                <InfoOutlined sx={{ color: "grey.300" }} />
              </Tooltip>
              <P variant="sm" sx={{ color: "grey.300" }}>
                {lensCase.reviewStatusReason}
              </P>
            </Box>
          )}
        </Box>
        {reviewButton(lensCase.reviewStatus)}
      </Box>
    </Box>
  );
};

export default CaseActions;
